import { Component, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import axios from 'axios';
import { smartWishlistService } from './../../services/wishlistService';
import { debounce } from 'lodash';

declare global {
    interface Window {

        // eslint-disable-next-line @typescript-eslint/naming-convention
        SWGetExpressWishlistId?: {
            (): string;
        };
    }
}

@Component
export class WishlistCount extends ThemeComponent {
    @Prop({ default: '' }) customerId!: string;

    init() {
        void this.handleCount();
        smartWishlistService.onWishlistUpdated.subscribe(debounce(() => {
            void this.handleCount();
        }, 300));
    }

    async handleCount() {

        // Determine API endpoint
        let apiEndpoint: string|null = null;
        if (this.customerId !== '') {
            apiEndpoint = `/a/wishlist?type=api&customerid=${this.customerId}&version=1`;
        } else {
            if (typeof window.SWGetExpressWishlistId !== 'undefined') {
                const wishlistId = window.SWGetExpressWishlistId();
                apiEndpoint = `/a/wishlist?type=api&wishlistid=${wishlistId}&version=1`;
            }
        }
        if (apiEndpoint === null) {
            this.$log.warn(`Wishlist API endpoint was not able to be determined`);
            this.classList.add('wishlist-count--hidden');
            return;
        }

        // Make API request
        const response = await axios.get(apiEndpoint);

        // Get count, update content
        const count = response.data.count;
        this.textContent = count;

        // Update visibility class
        if (count <= 0) {
            this.classList.add('wishlist-count--hidden');
        } else {
            this.classList.remove('wishlist-count--hidden');
        }
    }
}
